export class Reporting {
    /**
     * Scans all JS resource performance entries and logs a table of any scripts
     * that were loaded or downloaded more than once, indicating duplicate loading.
     */
    static reportDuplicatedResources() {
        // Group JS resource timing entries by filename (query string stripped)
        const scriptFileMap = {};
        const allResourceEntries = performance.getEntriesByType('resource');
        allResourceEntries
            .filter((entry) => /\.js(\?|$)/i.test(entry.name))
            .forEach((entry) => {
            var _a, _b;
            // Strip query string and extract just the filename from the full URL
            const fileName = (_a = entry.name.split('?')[0].split('/').pop()) !== null && _a !== void 0 ? _a : '';
            ((_b = scriptFileMap[fileName]) !== null && _b !== void 0 ? _b : (scriptFileMap[fileName] = [])).push(entry);
        });
        // Build a summary row per file, then keep only those loaded or downloaded more than once
        const duplicates = Object.entries(scriptFileMap)
            .map(([fileName, entries]) => ({
            file: fileName,
            // How many times the script was requested via a <script> tag
            scriptLoads: entries.filter(entry => entry.initiatorType === 'script').length,
            // How many times the script was actually downloaded from the network (transferSize > 0 means not served from cache)
            realDownloads: entries.filter(entry => entry.transferSize > 0).length,
        }))
            .filter(row => row.scriptLoads > 1 || row.realDownloads > 1);
        console.table(duplicates);
    }
}
